// @ts-nocheck
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import styles from './footer.module.scss';
import { T } from '@/v2/helpers/i18n';
import ManageTicketButton from './manageTicketButton/manageTicketButton';
import { RedemptionDisabledReasons } from '@/v2/wallet/manage/redemption/redemptionDisabledReasons.ts';
import Banner from '@/v2/partials/banner/banner.tsx';
import { RootContext, StateContext } from '@/root/root.provider.tsx';

type Props = {
  activeToken: string;
  event: EventModel;
  redemptionAvailability: RedemptionAvailabilityModel;
  tmOrderUrl: string;
} & T;
type State = {};

class Footer extends Component<Props, State> {
  static contextType: React.Context<StateContext> = RootContext;

  render() {
    const { banner } = this.context.state;
    const { activeToken, event, redemptionAvailability, tmOrderUrl } = this.props;
    return (
      ![RedemptionDisabledReasons.FORCED, RedemptionDisabledReasons.MULTI_EVENT].includes(
        redemptionAvailability.reason,
      ) && (
        <section className={styles.ticketFooter}>
          {!!banner && (
            <div>
              <Banner config={banner} />
            </div>
          )}
          <ManageTicketButton
            activeToken={activeToken}
            event={event}
            redemptionAvailability={redemptionAvailability}
            tmOrderUrl={tmOrderUrl}
          />
        </section>
      )
    );
  }
}

export default withTranslation('translation')(Footer);
